module.exports = __webpack_public_path__ + "media/images/builder/placeholder-gray-906e6ca1faa59b6d60052fe955cc1b4b.webp";